import React, { PureComponent } from 'react'
import { reduxForm } from 'redux-form'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Element } from 'react-scroll'
import { dossierTypes as dossierTypesConstant } from '../../../constants/dossier/common/dossierTypes'
import { compareObjects } from '../../../util/utils'
import { getComponentsPermisions } from '../../../util/permisionFunctions'
import ButtonsHeader from '../../../components/dossiers/common/ButtonsHeader'
import ButtonsSidebar from '../../dossiers/common/ButtonsSidebar'
import RejectCommentModal from '../../../components/dossiers/common/RejectCommentModal'
import { buttonsHeader } from '../../../constants/dossier/common/buttonsHeader'
import { permissions } from '../../../constants/backendIds'
import DocumentaryManagementPage from '../../../containers/dossiers/commons/DocumentaryManagementPage'
import AuditInfo from '../../dossiers/common/audit/AuditInfo'
import TrackingContainer from '../../../containers/tracking/trackingContainer'
import { TrackedPages } from '../../../constants/tracking/TrackedPages'
import Vehicle from '../../dossiers/common/Vehicle'
import { buttonsSidebar } from '../../../constants/dossier/common/buttonsSidebar'
import Reception from '../../dossiers/common/Reception'
import DossierRating from '../../dossiers/stock/DossierRating'
import Cleaning from '../../dossiers/stock/Cleaning'
import Checklist from '../../dossiers/stock/Checklist'
import Entry from '../../dossiers/stock/Entry'
import DossierBudget from '../../dossiers/common/DossierBudget'
import PriceChange from '../../dossiers/stock/PriceChange'
import Photographs from '../../dossiers/stock/Photographs'
import Crane from '../../dossiers/stock/Crane'
import Reconditioning from '../../dossiers/stock/Reconditioning'
import DossierSummary from '../../dossiers/common/DossierSummary'
import DossierHeaderPage from '../../../containers/dossiers/commons/dossierHeaderPage'
import RelatedDossiers from '../../dossiers/common/RelatedDossiers'
import CommentComponent from '../../dossiers/common/comment/CommentComponent'

class StockHistorical extends PureComponent {
  constructor () {
    super()
    this.state = {
      modalOpen: true,
      summaryOpen: true,
      showRejectCommentModal: false,
      activeTabConfiguration: null,
      headerTabConfiguration: null,
      loaded: false,
      componentsConfiguration: {
        downloadDocumentsButton: null,
        vehicle: null,
        stock: null,
        dossier_rating: null,
        cleaning: null,
        checklist: null,
        entry: null,
        reception: null,
        reconditioning: null,
        dossierBudget: null,
        priceChange: null,
        crane: null,
        photographs: null
      },
      isVehicleLoaded: false,
      isBudgetLoaded: false
    }
    this.goBack = this.goBack.bind(this)
  }

  goBack () {
    this.props.actions.setActiveTab(buttonsHeader.datos_expediente)
    this.props.history.goBack()
  }

  toggleRejectCommentModal (showRejectCommentModal) {
    this.setState({ showRejectCommentModal })
  }

  onClickRelatedDossierColumn (columnCode) {
    let columnCodeOrder = '+' + columnCode
    if (columnCodeOrder === this.props.relatedDossiersOrderBy) {
      columnCodeOrder = '-' + columnCode
    }
    this.props.actions.fetchFilteredRelatedDossier(this.props.dossier.dossierId, columnCodeOrder, true)
  }

  getRelatedDossierColumnIcon (columnCode) {
    if ('+' + columnCode === this.props.relatedDossiersOrderBy) {
      return 'ico-sort-selected-asc'
    } else if ('-' + columnCode === this.props.relatedDossiersOrderBy) {
      return 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  fetchStockDossierPromise (dossierId) {
    return new Promise((resolve, reject) => {
      return this.props.actions.fetchStockDossier(dossierId, resolve, reject, true)
    })
  }

  initializePermisions (props) {
    const componentKeys = Object.keys(this.state.componentsConfiguration)
    const newState = getComponentsPermisions(props.dossier.viewConfiguration.tabsConfiguration, props.activeTab, componentKeys)
    this.setState({ ...this.state, ...newState })
  }

  componentDidMount () {
    this.props.actions.restartStockDossierState()
    this.fetchStockDossierPromise(this.props.match.params.dossierId).then(() => {
      const form = { ...this.props.dossier }
      this.props.initialize(form)
      this.initializePermisions(this.props)
      this.props.trackVisitPage({
        documentTitle: TrackedPages.SERVICE_HISTORICAL,
        organizedUnitId: this.props.dossier.organizedUnitId,
        href: window.location.href
      })
      this.props.actions.fetchSameLevelOusCombo(this.props.dossier.organizedUnitId, null)
      this.props.actions.fetchRatingCombo()
      this.setState({ loaded: true })
      this.props.actions.registerLastAccess(this.props.match.params.dossierId, true)
    })
  }

  getSnapshotBeforeUpdate (prevProps) {
    if (this.props.dossier && this.props.dossier.viewConfiguration && this.props.dossier.viewConfiguration.tabsConfiguration && !compareObjects(prevProps.dossier.viewConfiguration.tabsConfiguration || {}, this.props.dossier.viewConfiguration.tabsConfiguration, true)) {
      this.initializePermisions(this.props)
    }
    if (this.props.dossier.dossierId && prevProps.activeTab !== this.props.activeTab) {
      this.initializePermisions(this.props)
    }
    return this.props
  }

  componentDidUpdate (prevProps) {
    if ((this.props.showManagementModal && !prevProps.showManagementModal) || (this.props.match.params.dossierId !== prevProps.match.params.dossierId)) {
      if (this.props.match.params.dossierId !== prevProps.match.params.dossierId) {
        this.props.actions.restartStockDossierState()
        this.props.actions.setScrollTo(buttonsSidebar.stock)
        this.props.actions.setActiveSection(buttonsSidebar.stock)
        this.props.actions.setActiveTab(buttonsHeader.datos_expediente)
        this.props.actions.closeAddOrEditDocumentModal()
      }

      if (this.props.match.params.dossierId) {
        this.fetchStockDossierPromise(this.props.match.params.dossierId).then(() => {
          const form = { ...this.props.dossier }
          this.props.initialize(form)
          this.initializePermisions(this.props)
          this.setState({ loaded: true })
        })
      }
    }

    if (this.props.dossier && this.props.dossier.dossierId && this.props.statusHeaderHeight && this.props.activeSection !== prevProps.activeSection) {
      switch (this.props.activeSection) {
        case buttonsSidebar.stock:
          this.setState({ summaryOpen: true })
          break
      }
      this.props.actions.setScrollTo(this.props.activeSection)
      this.props.actions.setActiveSection(false)
    }
  }

  componentWillUnmount () {
    this.props.actions.setActiveSection(buttonsSidebar.stock)
    this.props.actions.setScrollTo(null)
    this.props.actions.resetButtonsHeader()
    this.props.actions.closeAddOrEditDocumentModal()
    this.props.actions.restartStockDossierState()
  }

  handleToUpdateComponent (component) {
    if (component.isVehicleLoaded === false || buttonsSidebar.vehicle === component) this.setState({ isVehicleLoaded: true })
    if (component.isBudgetLoaded === false || buttonsSidebar.dossierBudget === component) this.setState({ isBudgetLoaded: true })
    this.props.actions.setScrollTo(component)
  }

  togglePanel () {
    if (this.state.summaryOpen) {
      this.props.actions.setActiveSection(false)
    }
    this.setState({ summaryOpen: !this.state.summaryOpen })
  }

  toogleHidedossierBodyLeft () {
    this.setState({ dossierBodyLeftClose: !this.state.dossierBodyLeftClose })
  }

  render () {
    const {
      t, dossier, pristine, activeTab, buttonsHeaderHeight, statusHeaderHeight, windowWidth, documentExport, vehicleProps, combos, activeSection, change,
      dossierRatingComponent, handleSubmit,
      dossier: {
        dossierId, header, checkListHeader, comments, viewConfiguration, dossierRelatedDossiers, auditInfo, dossierSubTypeId, dossierParentId,
        vehicleComponent: { vehicleId },
        viewConfiguration: { buttonsPermission = [] }
      },
      actions: {
        openDocumentModal, setActiveTab, setButtonsHeaderHeight, resetButtonsHeader, setActiveSection, setScrollerOptions,
        refreshAuditInfo, saveSelectedDocuments, fetchStockDossierVehicleHistorical, fetchComboOrigin, fetchComboDestination, fecthFamily,
        fetchAuditDetails, fetchAuditDetailsModal, getDossierBudget,
        fetchDossierBudgetRating, fetchDocumentsGroupedAuditDetails, fetchDocumentsGroupedAuditDetailsModal, fetchFilteredRelatedDossier,
        updateComment, createComment, deleteComment, markCommentAsRead
      }
    } = this.props

    if (!dossierId) return null
    const tKey = 'DOSSIER_COMPONENTS.'
    const panelsPaddingTop = statusHeaderHeight + buttonsHeaderHeight - 82
    const saveStockDossierPermission = buttonsPermission.includes('stock_dossier_save')
    return (
      <div className="dossierGrid">
        <div className='modalsContainer'>
          {this.state.showRejectCommentModal && <RejectCommentModal
            t={t}
            showModal={this.state.showRejectCommentModal}
            actions={{
              closeModal: () => this.toggleRejectCommentModal(false)
            }}
          />}
        </div>
        <div className="dossierGridPart-header">
          <DossierHeaderPage
            headerData={header}
            stages={checkListHeader}
            dossierType={dossierTypesConstant.stock}
            headerTabConfiguration={this.state.headerTabConfiguration}
            goBack={this.goBack}
            dossierId={dossier.dossierId}
            isHistorical={true}
            entityComponent = {dossier.entityComponent}
            vehicleComponent = {dossier.vehicleComponent}
          />
        </div>
        <div className="dossierGridPart-body">
          <div className={'dossierBody-left ' + (this.state.dossierBodyLeftClose ? 'close' : '') }>

            <DossierSummary
              t = {t}
              dossier={dossier}
              header={header}
              dossierType={dossierTypesConstant.sales}
              dossierSubType={dossierSubTypeId}
              brandCombo = {combos.brandCombo}
              entityTypeCombo = {combos.entityTypeCombo}
              dossierRelatedDossiers = {dossierRelatedDossiers}
            >
            </DossierSummary>
          </div>
          <div className='dossierBody-center'>
            <OverlayTrigger placement="right" overlay={<Tooltip id="editProductTooltip">{`${t((this.state.dossierBodyLeftClose ? 'GLOBAL.TABLES.SHOW_INNER_MENU' : 'GLOBAL.TABLES.HIDE_INNER_MENU'))}`}</Tooltip>}>
              <a onClick={() => this.toogleHidedossierBodyLeft()} className={'closeDossierInfo ' + (this.state.dossierBodyLeftClose ? '' : 'closeInnerMenu')}><i className={this.state.dossierBodyLeftClose ? 'iDocIcon-Open-inner-menu' : 'iDocIcon-Close-inner-menu'}></i></a>
            </OverlayTrigger>
          </div>

          <div className='dossierBody-right'>
            <div className="dossierGridPart-sectionsMenu">
              <ButtonsHeader
                t={t}
                pristine={pristine}
                actions={{
                  openDocumentModal: () => openDocumentModal(dossierId, dossierTypesConstant.stock, pristine, 1, true),
                  setActiveTab,
                  setButtonsHeaderHeight,
                  resetButtonsHeader,
                  setScrollerOptions
                }}
                viewConfiguration={viewConfiguration}
                dossierId={this.props.match.params.dossierId}
                dossierType={dossierTypesConstant.stock}
                activeTab={activeTab}
                marginTop={statusHeaderHeight}
                windowWidth={windowWidth}
                historical={true}
              />
            </div>
            <div className="dossierGridPart-ComponentSection">
              <form autoComplete="off">
                {
                  activeTab === buttonsHeader.datos_expediente && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="_nd dossierGridPart-ComponentSection-Inner" >
                      <div className="ComponentSection-InnerMennu">
                        <ButtonsSidebar
                          t={t}
                          dossierId={dossierId}
                          historical={true}
                          handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                          pristine={pristine}
                          actions={{ setActiveSection, fetchStockDossierVehicleHistorical }}
                          dossierType={dossierTypesConstant.stock}
                          marginTop={statusHeaderHeight}
                          dossierSubTypes={dossierSubTypeId}
                          buttonsHeaderHeight={buttonsHeaderHeight}
                          tabConfiguration={this.state.activeTabConfiguration}
                          isVehicleLoaded={this.state.isVehicleLoaded}
                        />
                      </div>
                      <div className="ComponentSection-InnerData" id="dossierData" >

                        {this.state.componentsConfiguration.vehicle && this.state.componentsConfiguration.vehicle.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.vehicle}>
                            <Vehicle
                              parentDossierType={{
                                isPaperwork: false,
                                isSales: false,
                                isPurchase: false,
                                isRegistrationDelivery: false,
                                isStock: true
                              }}
                              actions={{
                                fetchComboOrigin,
                                fetchComboDestination,
                                fetchStockDossierVehicleHistorical,
                                fecthFamily,
                                setActiveSection
                              }}
                              t={t}
                              dossierId={dossierId}
                              dossierType={dossierTypesConstant.stock}
                              handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                              isVehicleLoaded={this.state.isVehicleLoaded}
                              searchedVehicleProps={vehicleProps}
                              dossierSubType={dossierSubTypeId}
                              dossierParentId={dossierParentId}
                              dossierWithVehicle={!!vehicleId}
                              combos={combos}
                              readOnlyFields={!saveStockDossierPermission || !!dossierParentId}
                              open={activeSection === buttonsSidebar.vehicle}
                              componentConfiguration={this.state.componentsConfiguration.vehicle}
                              organizedUnitId={dossier.organizedUnitId}
                              isHistorical={true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.entry && this.state.componentsConfiguration.entry.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.entry}>
                            <Entry
                              t={t}
                              open={activeSection === buttonsSidebar.entry}
                              componentConfiguration={this.state.componentsConfiguration.entry}
                              dossier={dossier}
                              dossierId={dossierId}
                              actions={{
                                setActiveSection
                              }}
                              combos={combos}
                              readOnlyFields={true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.reception && this.state.componentsConfiguration.reception.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.reception}>
                            <Reception
                              pristine={pristine}
                              dossierType={dossierTypesConstant.stock}
                              t={t}
                              dossierId={dossierId}
                              open={activeSection === buttonsSidebar.reception}
                              dossierSubType={dossierSubTypeId}
                              componentConfiguration={this.state.componentsConfiguration.reception}
                              organizedUnitId={dossier.organizedUnitId}
                              parentDossierType={{
                                isPaperwork: false,
                                isSales: false,
                                isPurchase: true,
                                isCampaign: false,
                                isRegistrationDelivery: false,
                                isStock: false
                              }}
                              dossier={dossier}
                              readOnlyFields={true}
                              actions={{
                                setActiveSection
                              }}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.dossier_rating && this.state.componentsConfiguration.dossier_rating.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.reception}>
                            <DossierRating
                              pristine={pristine}
                              t={t}
                              historical={true}
                              dossierId={dossierId}
                              combos={combos}
                              componentConfiguration={this.state.componentsConfiguration.dossier_rating}
                              open={activeSection === buttonsSidebar.dossier_rating}
                              dossier={dossier}
                              dossierRatingComponent={ dossierRatingComponent}
                              handleSubmit={handleSubmit}
                              actions={{
                                change,
                                setActiveSection
                              }}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.dossierBudget && this.state.componentsConfiguration.dossierBudget.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.dossierBudget}>
                            <DossierBudget
                              pristine={pristine}
                              dossierType={dossierTypesConstant.stock}
                              t={t}
                              dossierId={dossierId}
                              actions={{
                                setActiveSection,
                                getDossierBudget,
                                fetchDossierBudgetRating
                              }}
                              open={activeSection === buttonsSidebar.dossierBudget}
                              dossierSubType={dossierSubTypeId}
                              componentConfiguration={this.state.componentsConfiguration.dossierBudget}
                              organizedUnitId={dossier.organizedUnitId}
                              dossier={dossier}
                              readOnlyFields={true}
                              handleToUpdateComponent={this.handleToUpdateComponent.bind(this)}
                              isBudgetLoaded={this.state.isBudgetLoaded}
                              historical={true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.entry && this.state.componentsConfiguration.reconditioning.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.reconditioning}>
                            <Reconditioning
                              t={t}
                              open={activeSection === buttonsSidebar.reconditioning}
                              componentConfiguration={this.state.componentsConfiguration.reconditioning}
                              dossier={dossier}
                              dossierId={dossierId}
                              actions={{
                                setActiveSection
                              }}
                              readOnlyFields={true}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.cleaning && this.state.componentsConfiguration.cleaning.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.cleaning}>
                            <Cleaning
                              dossierType={dossierTypesConstant.stock}
                              t={t}
                              dossierId={dossierId}
                              historical={true}
                              open={activeSection === buttonsSidebar.cleaning}
                              componentConfiguration={this.state.componentsConfiguration.cleaning}
                              dossier={dossier}
                              actions={{
                                setActiveSection
                              }}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.checklist && this.state.componentsConfiguration.checklist.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.checklist}>
                            <Checklist
                              historical={true}
                              dossierType={dossierTypesConstant.stock}
                              t={t}
                              dossierId={dossierId}
                              open={activeSection === buttonsSidebar.checklist}
                              componentConfiguration={this.state.componentsConfiguration.checklist}
                              dossier={dossier}
                              actions={{
                                setActiveSection
                              }}
                            />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.photographs && this.state.componentsConfiguration.photographs.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.photographs}>
                            <Photographs
                              dossierType={dossierTypesConstant.stock}
                              t={t}
                              dossierId={dossierId}
                              isHistorical={true}
                              open={activeSection === buttonsSidebar.photographs}
                              componentConfiguration={this.state.componentsConfiguration.photographs}
                              dossier={dossier}
                              actions={{
                                setActiveSection
                              }}
                            />
                          </Element>
                        )}

                        {this.state.componentsConfiguration.crane && this.state.componentsConfiguration.crane.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.crane}>
                            <Crane
                              t={t}
                              open={activeSection === buttonsSidebar.crane}
                              componentConfiguration={this.state.componentsConfiguration.crane}
                              dossier={dossier}
                              dossierId={dossierId}
                              combos={combos}
                              readOnlyFields={true}
                              actions={{
                                setActiveSection
                              }} />
                          </Element>
                        )}
                        {this.state.componentsConfiguration.priceChange && this.state.componentsConfiguration.priceChange.permission > permissions.hidden && (
                          <Element name={buttonsSidebar.price_change}>
                            <PriceChange
                              t={t}
                              open={activeSection === buttonsSidebar.price_change}
                              componentConfiguration={this.state.componentsConfiguration.priceChange}
                              dossier={dossier}
                              actions={{
                                setActiveSection
                              }}
                              readOnlyFields={true}/>
                          </Element>
                        )}

                      </div>

                    </div>
                  )}
                {activeTab === buttonsHeader.gestor_documental && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                  <div className="dossierGridPart-ComponentSection-Inner sales-panel gestorDocumental">
                    <div className="ComponentSection-InnerData">
                      <DocumentaryManagementPage
                        dossier={dossier}
                        dossierType={dossierTypesConstant.stock}
                        saveSelectedDocuments={saveSelectedDocuments}
                        documentExport={documentExport}
                        combos={this.props.combos}
                        isHistorical={true}
                        tabConfiguration={this.state.activeTabConfiguration}
                        configuration={this.state.activeTabConfiguration}
                        downloadButtonPermission={this.state.activeTabConfiguration.componentsConfiguration.downloadDocumentsButton}
                      />
                    </div>
                  </div>
                )}
                {activeTab === buttonsHeader.expedientes_relacionados && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                  <div className="dossierGridPart-ComponentSection-Inner related-dossiers-table">
                    <div className="ComponentSection-InnerData">
                      <RelatedDossiers
                        t={t}
                        relatedDossiersOrderBy = {this.props.relatedDossiersOrderBy}
                        panelsPaddingTop = {panelsPaddingTop}
                        history = {this.props.history}
                        dossierRelatedDossiers = {dossierRelatedDossiers}
                        dossierId= {dossierId}
                        isHistorical= {true}
                        actions={{ fetchFilteredRelatedDossier }}
                      />
                    </div>
                  </div>
                )}
                {
                  activeTab === buttonsHeader.actividad_expediente && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="dossierGridPart-ComponentSection-Inner auditInfo">
                      <div sm={12} className="ComponentSection-InnerData">
                        <AuditInfo
                          auditInfo={auditInfo}
                          dossierType={dossierTypesConstant.stock}
                          actions={{ refreshAuditInfo, fetchAuditDetails, fetchAuditDetailsModal, fetchDocumentsGroupedAuditDetails, fetchDocumentsGroupedAuditDetailsModal }}
                          dossier={dossier}
                          historical={true}
                          t={t}
                        />
                      </div>
                    </div>
                  )
                }
                {
                  activeTab === buttonsHeader.observaciones && this.state.activeTabConfiguration && this.state.activeTabConfiguration.permission > permissions.hidden && (
                    <div className="dossierGridPart-ComponentSection-Inner commentComponent">
                      <div className="ComponentSection-InnerData">
                        <CommentComponent
                          comments={comments}
                          actions={{ updateComment, createComment, deleteComment, markCommentAsRead }}
                          readOnlyFields={!saveStockDossierPermission}
                          dossierType="stockDossier"
                          t={t}
                          tKey={tKey}
                          combos={{ allReasonCombo: this.props.combos.allReasonCombo }}
                          openComponent={activeTab === buttonsHeader.observaciones}
                          dossierId={this.props.dossier.dossierId}
                          historical={true}
                        />

                      </div>
                    </div>
                  )
                }
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

var decoratedComponent = TrackingContainer(StockHistorical, false)

export default reduxForm({
  form: 'stock_dossier'
})(decoratedComponent)
